import React from 'react';

import { DxCheckbox, DxList } from '@dvag/design-system-react';
import { CheckBoxGroupProps, SaverFields, SaverFieldType } from 'type/savingType';
import { useReadOnlyMode } from 'hooks/useReadOnlyMode';
import { checkboxLabelMap } from './util';
import './checkBoxStyle.modal.css';

export const CheckBoxGroup = ({
  register,
  checkBoxList,
  setValue,
  getValues,
}: CheckBoxGroupProps) => {
  const readOnly = useReadOnlyMode();

  return (
    <DxList>
      {checkBoxList.map((checkBox, index) => (
        <DxCheckbox
          data-testid={`${checkBox.name}-checkbox`}
          label={checkboxLabelMap[checkBox.name]}
          key={checkBox.name}
          id={checkBox.name}
          disabled={readOnly}
          className={index === checkBoxList.length - 1 ? 'checkbox' : 'checkbox-bordered'}
          {...register(SaverFieldType[checkBox.name as keyof SaverFields])}
          checked={getValues(checkBox.name) as boolean | undefined}
          onCheckedChange={(e) => {
            setValue?.(checkBox.name, e.detail);
          }}
        />
      ))}
    </DxList>
  );
};
